<template>
  <div class='progress-bar-container'>
    <div class="themeIconWrapper" id="iconOutline">
      <img class="themeIcon" :src="icon" />
    </div>
    <progress-bar
      :total-units="totalUnits"
      :completed-units="completedUnits"
    >
    </progress-bar>
  </div>
</template>

<script>
import digitalCitizenshipIcon from 'assets/images/DigitalCitizenship_Icon.png';
import ProgressBar from './ProgressBar.vue';

export default {
  components: {
    ProgressBar
  },
  props: {
    completedUnits: {
      type: Number
    },
    totalUnits: {
      type: Number
    }
  },

  data() {
    return {
      icon: digitalCitizenshipIcon
    };
  }
};
</script>

<style lang=scss scoped>
.progress-bar-container {
  border: 3.5px solid black;
  border-radius: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
}
</style>
